import {VariableAbstract} from "./VariableAbstract";
import {ISyncstep, TBaseOrObservableType, TRouteId} from "../../index";
import {TServiceName, TServiceParameters} from "../../constants/ApiServices";
import {nsTooltip} from "../../util/nsTooltip";
import {getAnyValue} from "../../util/misc";
import {nsSync} from "../../util/nsSync";

export {template} from "./VariableAbstract"

export class viewModel extends VariableAbstract<ISyncstep> {
    protected routeId: TRouteId = 'syncstatusv2'
    protected serviceName: TServiceName = 'getsyncsteps'

    protected override getParams(): TServiceParameters {
        return {}
    }

    protected override getTitle(): string {
        return nsTooltip.getTitle_syncstep(getAnyValue(this.item))
    }

    protected override onSuccess(item: TBaseOrObservableType<ISyncstep>) {
        super.onSuccess(item)
        this.isReady(false)
        this.name = nsSync.getSyncstepName(getAnyValue(this.item))
        this.isReady(true)
    }

}